
import { TypedVue } from "@/store/types";
import { Component, Inject, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { EvaluationReportData } from "@/store/admin/adminTypes";
import { buildCandidateSummaries, CandidateSummary } from "./shared";
import CandidateFitCard from "./CandidateFitCard.vue";
import PrioritizationLegend from "./PrioritizationLegend.vue";

@Component({
  components: {
    CandidateFitCard,
    PrioritizationLegend,
  },
})
export default class AtAGlanceTab extends TypedVue {
  // Shadows the global $i18n with the per-report instance provided by the view,
  // so $t() also resolves the merged project-report:search-report literals.
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ required: true })
  readonly reportData!: EvaluationReportData;

  @Prop({ required: true })
  readonly sortedAssessments!: EvaluationReportData["assessments"];

  @Prop({ default: false })
  readonly printing!: boolean;

  // Candidates only — managers and team members are not ranked against the role.
  get summaries(): CandidateSummary[] {
    return buildCandidateSummaries(this.sortedAssessments, this.reportData).filter((s) => s.isCandidate);
  }

  get zones() {
    return [
      { key: "must", labelKey: "Priority::MustHaves", traits: this.getTraitPriorities(2) },
      { key: "nice", labelKey: "Priority::NiceToHaves", traits: this.getTraitPriorities(1) },
      { key: "neutral", labelKey: "Priority::Neutral", traits: this.getTraitPriorities(0) },
    ];
  }

  getTraitPriorities(level: number) {
    return Object.keys(this.reportData?.traitPriorities || {}).filter((trait) => this.reportData?.traitPriorities[trait] === level);
  }
}
